import React, {
    createContext,
    Dispatch,
    SetStateAction,
    useCallback,
    useContext,
    useState
} from 'react'
import { CompoundType } from 'compoundTypes'
import { GdsFilter } from 'tableTypes'
import { toggleCheckboxListFilter } from 'utils/evidenceFilterUtil'

interface CompoundFilterContextType {
    activeGdsFilter: GdsFilter
    setActiveGdsFilter: Dispatch<SetStateAction<GdsFilter>>
    activeSelectFilters: CompoundType[]
    handleActiveSelectFilterChange: (v: CompoundType) => void
}

const CompoundFilterContext = createContext<
    CompoundFilterContextType | undefined
>(undefined)

export const useCompoundFilterContext = () => {
    const ctx = useContext(CompoundFilterContext)
    if (!ctx)
        throw new Error(
            'useCompoundFilterContext must be used within CompoundFilterProvider'
        )
    return ctx
}

export const CompoundFilterProvider: React.FC<{
    children: React.ReactNode
}> = ({ children }) => {
    const [activeGdsFilter, setActiveGdsFilter] = useState<GdsFilter>('')
    const [activeSelectFilters, setActiveSelectFilters] = useState<
        CompoundType[]
    >([])

    const handleActiveSelectFilterChange = useCallback(
        (selectedFilter: CompoundType) => {
            setActiveSelectFilters((prev) =>
                toggleCheckboxListFilter(prev, selectedFilter)
            )
        },
        []
    )

    return (
        <CompoundFilterContext.Provider
            value={{
                activeGdsFilter,
                setActiveGdsFilter,
                activeSelectFilters,
                handleActiveSelectFilterChange
            }}
        >
            {children}
        </CompoundFilterContext.Provider>
    )
}
